// Archoil Existing Customer Survey
// Homepage URL-triggered popup survey for Klaviyo email traffic.
// Trigger URL: https://www.archoil.com/?customer_survey=1&email={{ person.email|urlencode }}

window.__archoil_customer_survey_loaded = true;

(function () {
  'use strict';

  var SURVEY_SOURCE = 'Archoil Existing Customer Survey';
  var EVENT_STARTED = 'Archoil Existing Customer Survey Started';
  var EVENT_ANSWERED = 'Archoil Existing Customer Survey Answered';
  var EVENT_SUBMITTED = 'Archoil Existing Customer Survey Submitted';
  var EVENT_ENTERED = 'Archoil Existing Customer Survey Competition Entry';
  var EVENT_CLOSED = 'Archoil Existing Customer Survey Closed';

  var STORAGE_KEY = 'archoil_existing_customer_survey_state_v5';
  var RUN_ID_KEY = 'archoil_existing_customer_survey_run_id';
  var TRIGGER_PARAM = 'customer_survey';

  var CONFIG = {
    triggerValues: ['1', 'true', 'yes', 'test'],

    intro: {
      headline: 'Win 1 of 10 Diesel Fuel System Kits',
      subheading: 'Complete this quick 10-question survey and you’ll be entered for your chance to win. ',
      button: 'Start Survey',
      image: 'https://cdn.shopify.com/s/files/1/1997/2921/files/Win_DFSK_image.jpg?v=1779894492'
    },

    emailStep: {
      headline: 'THANK YOU FOR TAKING PART',
      subheading: 'Enter your email address so we can contact you if you win. Competition ends on June 19. Winners will be contacted before the end of June.',
      button: 'Enter the Giveaway',
      note: 'Your survey answers will help us better understand your vehicle needs. Entering your email confirms your entry into the Diesel Fuel System Kit giveaway. ',
      image: 'https://cdn.shopify.com/s/files/1/1997/2921/files/Win_DFSK_image-2-02.jpg?v=1780673089'
    },

    completion: {
      headline: 'You’re entered',
      subheading: 'Thanks for completing the survey. Your entry has been recorded. You will be contacted in June if you have won.',
      button: 'Close'
    },

    questions: [
      {
        id: 'engine_owned',
        prop: 'customer_survey_engine_owned',
        title: 'What type of engine(s) do you own or maintain?',
        type: 'single',
        required: true,
        options: [
          { id: 'diesel_only', label: 'Diesel Only', icon: 'engine:diesel' },
          { id: 'gasoline_only', label: 'Gasoline Only', icon: 'engine:gasoline' },
          { id: 'diesel_and_gasoline', label: 'Diesel and Gasoline', icon: 'engine:both' }
        ]
      },
      {
        id: 'vehicles_driven',
        prop: 'customer_survey_vehicles_driven',
        other_prop: 'customer_survey_vehicles_driven_other',
        other_prompt: 'What other vehicle or equipment do you use?',
        other_placeholder: 'Type your answer here',
        title: 'Which vehicles or equipment do you drive or use? (Select all that apply)',
        type: 'multi',
        required: true,
        options: [
          { id: 'light_heavy_duty_truck', label: 'Light/Heavy Duty Truck', icon: 'setup:heavy' },
          { id: 'class_4_8_semi_truck', label: 'Class 4-8 Vehicle', icon: 'setup:semi_truck' },
          { id: 'passenger_car_suv', label: 'Passenger Car/SUV', icon: 'setup:daily' },
          { id: 'agricultural_equipment', label: 'Agricultural Equipment', icon: 'setup:ag_offroad' },
          { id: 'heavy_equipment', label: 'Heavy Equipment', icon: 'setup:heavy_equipment' },
          { id: 'generator_small_engine', label: 'Generator/Small Engine', icon: 'setup:small_engine' },
          { id: 'marine_rv_powersports', label: 'Marine/RV/Powersports', icon: 'setup:recreational' },
          { id: 'other', label: 'Other', icon: 'general:other' }
        ]
      },
      {
        id: 'vehicles_maintained',
        prop: 'customer_survey_vehicles_maintained',
        title: 'How many vehicles do you help maintain?',
        type: 'single',
        required: true,
        options: [
          { id: '1', label: '1', icon: 'maintained:1' },
          { id: '2_3', label: '2-3', icon: 'maintained:2' },
          { id: '4_6', label: '4-6', icon: 'maintained:4_6' },
          { id: '7_plus', label: '7+', icon: 'maintained:7_plus' }
        ]
      },
      {
        id: 'small_engines_owned',
        prop: 'customer_survey_small_engines_owned',
        title: 'How many small engines or fuel-powered pieces of equipment do you own? (Generator, lawn mower, weed whacker etc.)',
        type: 'single',
        required: true,
        options: [
          { id: '0', label: '0', icon: 'small_engines:0' },
          { id: '1', label: '1', icon: 'small_engines:1' },
          { id: '2_3', label: '2-3', icon: 'small_engines:2_3' },
          { id: '4_5', label: '4-5', icon: 'small_engines:4_5' },
          { id: '6_plus', label: '6+', icon: 'small_engines:6_plus' }
        ]
      },
      {
        id: 'cares_about_most',
        prop: 'customer_survey_cares_about_most',
        other_prop: 'customer_survey_cares_about_most_other',
        other_prompt: 'What other benefit is important to you?',
        other_placeholder: 'Type your answer here',
        title: 'When choosing a fuel additive, which benefits matter most to you? (Choose up to 3)',
        type: 'multi',
        max_select: 3,
        required: true,
        options: [
          { id: 'improved_fuel_economy', label: 'Improved fuel economy (MPG)', icon: 'goal:improved_mpg' },
          { id: 'lifespan', label: 'Improved engine and component lifespan', icon: 'goal:lifespan' },
          { id: 'power_response', label: 'Improved power and response', icon: 'goal:power_response' },
          { id: 'reduced_dpf', label: 'Reduced DPF regen frequency', icon: 'goal:reduced_dpf' },
          { id: 'cold_weather_performance', label: 'Improved cold-weather performance', icon: 'goal:anti_gel' },
          { id: 'reduced_maintenance_costs', label: 'Reduced maintenance costs', icon: 'goal:reduce_maint' },
          { id: 'better_towing_performance', label: 'Better towing performance', icon: 'goal:towing' },
          { id: 'other', label: 'Other', icon: 'general:other' }
        ]
      },
      {
        id: 'archoil_usage_consistency',
        prop: 'customer_survey_archoil_usage_consistency',
        title: 'How consistently do you use Archoil products?',
        type: 'single',
        required: true,
        options: [
          { id: 'rarely', label: 'Rarely', icon: 'usage:rarely' },
          { id: 'occasionally', label: 'Occasionally', icon: 'usage:occasionally' },
          { id: 'regularly', label: 'Regularly', icon: 'usage:regularly' },
          { id: 'all_the_time', label: 'All the time', icon: 'usage:all_the_time' }
        ]
      },
      {
        id: 'customer_type',
        prop: 'customer_survey_customer_type',
        title: 'Which best describes you?',
        type: 'single',
        required: true,
        options: [
          { id: 'daily_driver', label: 'Daily Driver', icon: 'customer_type:everyday_vehicle_owner' },
          { id: 'diesel_enthusiast', label: 'Diesel Enthusiast', icon: 'customer_type:diesel_enthusiast' },
          { id: 'diy_mechanic', label: 'DIY Mechanic', icon: 'customer_type:diy_mechanic' },
          { id: 'professional_technician', label: 'Professional Technician', icon: 'customer_type:mechanic' },
          { id: 'fleet_manager', label: 'Fleet Manager', icon: 'customer_type:fleet_manager' },
          { id: 'professional_driver', label: 'Owner-Operator', icon: 'customer_type:professional_driver' },
          { id: 'construction_agriculture_operator', label: 'Construction/Agriculture Operator', icon: 'customer_type:construction_agriculture_operator' },
          { id: 'dealer_reseller', label: 'Dealer/Reseller', icon: 'customer_type:dealer' }
        ]
      },
      {
        id: 'not_bought_recently_reason',
        prop: 'customer_survey_not_bought_recently_reason',
        title: 'If you have not bought recently, what is the main reason?',
        type: 'single',
        required: true,
        options: [
          { id: 'still_have_product_left', label: 'I still have product left', icon: 'reason:still_have_product_left' },
          { id: 'bought_amazon_walmart', label: 'I bought through Amazon/Walmart instead', icon: 'reason:bought_amazon_walmart' },
          { id: 'only_buy_when_sale', label: 'I only buy when there is a sale', icon: 'reason:only_buy_when_sale' },
          { id: 'price_put_me_off', label: 'Price has put me off', icon: 'reason:price_put_me_off' },
          { id: 'switched_to_another_product', label: 'I switched to another product', icon: 'reason:switched_to_another_product' },
          { id: 'not_enough_knowledge', label: 'I do not know enough about the products', icon: 'reason:not_enough_knowledge' },
          { id: 'not_sure_what_to_buy_next', label: 'I was not sure what to buy next', icon: 'reason:not_sure_what_to_buy_next' },
          { id: 'bought_recently', label: 'I have bought recently', icon: 'reason:bought_recently' }
        ]
      },
      {
        id: 'maintenance_confidence',
        prop: 'customer_survey_maintenance_confidence',
        title: 'How confident are you performing vehicle maintenance?',
        type: 'scale',
        min: 1,
        max: 5,
        min_label: 'Beginner',
        max_label: 'Professional',
        required: true
      },
      {
        id: 'age_range',
        prop: 'customer_survey_age_range',
        title: 'What is your age range?',
        type: 'single',
        display: 'button_scale',
        required: true,
        options: [
          { id: '16_24', label: '16-24' },
          { id: '25_34', label: '25-34' },
          { id: '35_44', label: '35-44' },
          { id: '45_54', label: '45-54' },
          { id: '54_64', label: '55-64' },
          { id: '65_plus', label: '65+' }
        ]
      }
    ]
  };


  var ICONS = {
    // Question 1
    'engine:diesel': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Diesel.png?v=1779881860',
    'engine:gasoline': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Gas.png?v=1779881860',
    'engine:both': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Both_f476a96c-7240-4724-8159-d0371f604424.png?v=1780320839',

    // Question 2 - vehicle/equipment icons
    'setup:heavy': 'https://cdn.shopify.com/s/files/1/1997/2921/files/heavy_duty.png?v=1755177827',
    'setup:semi_truck': 'https://cdn.shopify.com/s/files/1/1997/2921/files/SemiTruck.png?v=1760956148',
    'setup:ag_offroad': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Agri_963981b7-4d54-414a-9acd-144c130626d7.png?v=1780505522',
    'setup:heavy_equipment': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Heavy_Equipment.png?v=1780505722',
    'setup:daily': 'https://cdn.shopify.com/s/files/1/1997/2921/files/daily_driver.png?v=1755177827',
    'setup:recreational': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Boats.png?v=1757495496',
    'setup:powerstroke': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Powerstroke.png?v=1757495496',
    'setup:small_engine': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Lawnmower.png?v=1757495496',
    'general:other': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Other.png?v=1780505723',

    // Question 3 - vehicle count icons
    'maintained:1': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_1.png?v=1779881860',
    'maintained:2': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_2.png?v=1779881860',
    'maintained:4_6': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_4-6.png?v=1780505522',
    'maintained:7_plus': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_7.png?v=1780505522',

    // Question 4 - small engine count icons
    'small_engines:0': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Small_engine_-_0.png?v=1780506871',
    'small_engines:1': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Small_engine_-_1.png?v=1780506871',
    'small_engines:2_3': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Small_engine_-_2-3.png?v=1780506871',
    'small_engines:4_5': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Small_engine_-_4-5.png?v=1780506871',
    'small_engines:6_plus': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Small_engine_-_6.png?v=1780506871',

    // Question 5 - benefit icons
    'goal:improved_mpg': 'https://cdn.shopify.com/s/files/1/1997/2921/files/MPG.png?v=1757495496',
    'goal:lifespan': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Extend.png?v=1757495496',
    'goal:reduced_dpf': 'https://cdn.shopify.com/s/files/1/1997/2921/files/DPF.png?v=1757495496',
    'goal:anti_gel': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Anti-gel.png?v=1757495496',
    'goal:power_response': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Power.png?v=1757495496',
    'goal:reduce_maint': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Costs.png?v=1757495496',
    'goal:towing': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Towing.png?v=1780505723',

    // Question 6 - usage consistency icons
    'usage:rarely': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Rarely.png?v=1780505723',
    'usage:occasionally': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Occasionally.png?v=1780505723',
    'usage:regularly': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Regularly.png?v=1780505723',
    'usage:all_the_time': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_All_the_time.png?v=1780505722',

    // Question 7 - persona icons
    'customer_type:everyday_vehicle_owner': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_daily_driver.png?v=1779881860',
    'customer_type:diesel_enthusiast': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_enthusiast.png?v=1779881860',
    'customer_type:diy_mechanic': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_DIY.png?v=1779881860',
    'customer_type:professional_driver': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Professional.png?v=1779881860',
    'customer_type:fleet_manager': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Fleet.png?v=1779881860',
    'customer_type:construction_agriculture_operator': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Agri_963981b7-4d54-414a-9acd-144c130626d7.png?v=1780505522',
    'customer_type:mechanic': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Mechanic.png?v=1779881860',
    'customer_type:dealer': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Dealer.png?v=1779881860',

    // Question 8 - purchase recency/friction icons
    'reason:still_have_product_left': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_stocked_up.png?v=1779881860',
    'reason:only_buy_when_sale': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_sale.png?v=1779881860',
    'reason:price_put_me_off': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_price.png?v=1779881860',
    'reason:switched_to_another_product': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_switched.png?v=1779881860',
    'reason:not_enough_knowledge': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Don_t_know_enough-35.png?v=1780672313',
    'reason:not_sure_what_to_buy_next': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Unsure.png?v=1779881860',
    'reason:bought_amazon_walmart': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Other_shop.png?v=1779881860',
    'reason:bought_recently': 'https://cdn.shopify.com/s/files/1/1997/2921/files/Survey_Icon_-_Ordered_44e5e862-3efb-4296-83a4-2a487ff03e0d.png?v=1779893884'
  };
  var state = {
    started: false,
    index: 0,
    answers: {},
    otherText: {},
    email: '',
    completed: false
  };

  var pendingOtherFocus = '';

  function getParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (_) {
      return '';
    }
  }

  function shouldOpenSurvey() {
    var value = String(getParam(TRIGGER_PARAM) || '').toLowerCase();
    return CONFIG.triggerValues.indexOf(value) > -1;
  }

  function getEmailFromUrl() {
    var keys = ['email', 'em', 'customer_email', 'kl_email'];
    for (var i = 0; i < keys.length; i++) {
      var value = getParam(keys[i]);
      if (value && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return value.trim();
    }
    return '';
  }

  function getRunId() {
    try {
      var id = sessionStorage.getItem(RUN_ID_KEY);
      if (!id) {
        id = 'ecs_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 9);
        sessionStorage.setItem(RUN_ID_KEY, id);
      }
      return id;
    } catch (_) {
      return 'ecs_' + Date.now().toString(36);
    }
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    attrs = attrs || {};

    Object.keys(attrs).forEach(function (key) {
      var value = attrs[key];

      if (key === 'class') {
        node.className = value;
      } else if (key === 'style') {
        node.setAttribute('style', value);
      } else if (key.indexOf('on') === 0 && typeof value === 'function') {
        node.addEventListener(key.slice(2), value);
      } else if (value !== false && value != null) {
        node.setAttribute(key, value === true ? key : value);
      }
    });

    (children || []).forEach(function (child) {
      node.appendChild(typeof child === 'string' ? document.createTextNode(child) : child);
    });

    return node;
  }

  function scrollSurveyToTop() {
    try {
      var root = document.querySelector('.ecs-root');
      if (root) {
        root.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      var modal = document.querySelector('.ecs-modal');
      if (modal) {
        modal.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (_) {}
  }

  function clear(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  function getQuestion(id) {
    return CONFIG.questions.filter(function (question) {
      return question.id === id;
    })[0] || null;
  }

  function getOptionLabel(questionId, optionId) {
    var question = getQuestion(questionId);
    if (!question || !question.options) return String(optionId || '');

    var match = question.options.filter(function (option) {
      return option.id === optionId;
    })[0];

    return match ? match.label : String(optionId || '');
  }

  function answerLabel(question, value) {
    if (question.type === 'multi' && Array.isArray(value)) {
      return value.map(function (id) {
        return getOptionLabel(question.id, id);
      }).join(', ');
    }

    if (question.type === 'scale') return String(value || '');

    return getOptionLabel(question.id, value);
  }

  function isAnswered(question) {
    var value = state.answers[question.id];

    if (question.type === 'multi') return Array.isArray(value) && value.length > 0;

    return value !== undefined && value !== null && String(value) !== '';
  }

  function questionHasOther(question) {
    return !!(question && question.other_prop && Array.isArray(question.options) && question.options.some(function (option) {
      return option.id === 'other';
    }));
  }

  function isOtherSelected(question) {
    if (!questionHasOther(question)) return false;

    var value = state.answers[question.id];

    if (question.type === 'multi') {
      return Array.isArray(value) && value.indexOf('other') > -1;
    }

    return value === 'other';
  }

  function setOtherText(question, value, shouldTrack) {
    if (!questionHasOther(question)) return;

    state.otherText[question.id] = String(value || '').slice(0, 250);
    persist();

    if (shouldTrack) {
      savePartialToKlaviyo(question);
    }
  }

  function persist() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        started: state.started,
        index: state.index,
        answers: state.answers,
        otherText: state.otherText,
        email: state.email,
        completed: state.completed
      }));
    } catch (_) {}
  }

  function restore() {
    try {
      var saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!saved) return;

      state.started = !!saved.started;
      state.index = Number(saved.index || 0);
      state.answers = saved.answers || {};
      state.otherText = saved.otherText || {};
      state.email = saved.email || '';
      state.completed = !!saved.completed;
    } catch (_) {}
  }

  function getAttributionProps() {
  return {};
}

  function getAnswerProps() {
    var props = {};

    CONFIG.questions.forEach(function (question) {
      var value = state.answers[question.id];

      if (value === undefined || value === null || value === '') return;
      if (question.type === 'multi' && Array.isArray(value) && value.length === 0) return;

      props[question.prop] = answerLabel(question, value);

      if (isOtherSelected(question) && question.other_prop) {
        var otherValue = String((state.otherText && state.otherText[question.id]) || '').trim();
        if (otherValue) props[question.other_prop] = otherValue;
      }
    });

    return props;
  }

  function getAllProps(extra) {
  return Object.assign({}, getAttributionProps(), getAnswerProps(), extra || {});
}

  function klaviyoIdentify(email, props) {
    if (!email) return;

    try {
      var payload = Object.assign({ email: email, $email: email }, props || {});

      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify(payload);
      } else if (window._learnq) {
        window._learnq.push(['identify', payload]);
      }
    } catch (_) {}
  }

  function klaviyoTrack(eventName, props, email) {
    try {
      var payload = Object.assign({}, props || {});

      if (email) {
        payload.email = email;
        payload.$email = email;
      }

      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track(eventName, payload);
      } else if (window._learnq) {
        window._learnq.push(['track', eventName, payload]);
      }
    } catch (_) {}
  }

function knownEmail() {
  return getEmailFromUrl() || state.email;
}

function savePartialToKlaviyo(question) {
    var email = knownEmail();
    if (!email) return;

    var props = getAnswerProps();

    klaviyoIdentify(email, props);
    klaviyoTrack(EVENT_ANSWERED, props, email);
  }

  function injectStyles() {
    if (document.getElementById('archoil-existing-customer-survey-styles')) return;

    var css = '' +
      ':root{--ecs-orange:#ff6b00;--ecs-gray:#e6e6e6;--ecs-text:#111;--ecs-muted:#6b7280}' +
      '.ecs-lock{overflow:hidden!important}' +
      '.ecs-overlay{position:fixed;inset:0;background:rgba(0,0,0,.62);z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:18px}' +
      '.ecs-modal{width:min(1120px,100%);max-height:min(92vh,980px);background:#fff;border-radius:18px;box-shadow:0 24px 80px rgba(0,0,0,.32);position:relative;overflow:visible;display:flex;flex-direction:column}' +
      '.ecs-close{position:absolute;right:14px;top:12px;z-index:5;width:42px;height:42px;border-radius:999px;border:1px solid #e5e7eb;background:#fff;color:#111;font-size:26px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center}' +
      '@media(min-width:721px){.ecs-close{right:-58px;top:0}}' +
      '.ecs-close:hover{box-shadow:0 6px 18px rgba(0,0,0,.12)}' +
      '.ecs-root{overflow:auto;-webkit-overflow-scrolling:touch}' +
      '.ecs-wrap{max-width:80rem;margin:0 auto;padding:34px 24px 42px;color:var(--ecs-text);font-family:"DIN Next LT Pro","DIN Next","DIN",Inter,Arial,sans-serif}' +

      '.ecs-intro{max-width:42rem;margin:18px auto;padding:28px 24px;border:1px solid #e5e7eb;border-radius:14px;background:#fff;text-align:center}' +

      '.ecs-split-card{max-width:980px;margin:18px auto;padding:0;border:1px solid #e5e7eb;border-radius:18px;background:#fff;overflow:hidden;display:grid;grid-template-columns:1fr 1fr;align-items:stretch}' +
      '.ecs-split-media{background:#f3f4f6;min-height:420px;display:flex}' +
      '.ecs-split-media img{display:block;width:100%;height:100%;object-fit:cover}' +
      '.ecs-split-content{padding:42px 38px;display:flex;flex-direction:column;justify-content:center;text-align:center}' +
      '.ecs-split-content .ecs-kicker{margin-bottom:10px}' +
      '.ecs-split-content .ecs-h2{margin-bottom:12px}' +
      '.ecs-split-content .ecs-sub{margin-bottom:24px}' +
      '.ecs-split-content .ecs-help{max-width:34rem;margin:10px auto 0}' +

      '.ecs-kicker{text-transform:uppercase;letter-spacing:.08em;font-size:14px;font-weight:800;color:var(--ecs-orange);margin-bottom:8px}' +
      '.ecs-h2{font-weight:800;letter-spacing:-.02em;margin:0 0 10px;text-align:center;font-size:28px;line-height:1.1}' +
      '.ecs-sub{color:var(--ecs-muted);font-size:16px;line-height:1.5;margin:0 auto 20px;max-width:48rem;text-align:center}' +

      '.ecs-meta{display:flex;align-items:center;justify-content:space-between;margin:4px 0 8px;color:var(--ecs-muted);font-size:14px}' +
      '.ecs-progress .track{height:8px;background:var(--ecs-gray);border-radius:8px;overflow:hidden}' +
      '.ecs-progress .fill{height:100%;background:var(--ecs-orange);width:0;transition:width .25s ease}' +

      '.ecs-stage{margin-top:18px}' +
      '.ecs-options{display:flex;flex-wrap:wrap;justify-content:center;gap:18px}' +
      '.ecs-option{position:relative;width:220px;max-width:240px;aspect-ratio:1/1;border-radius:0;overflow:hidden;border:1px solid #e5e7eb;box-shadow:0 1px 2px rgba(16,24,40,.04);transition:border-color .2s,box-shadow .2s,transform .2s;background:#fff;cursor:pointer}' +
      '.ecs-option:hover{box-shadow:0 8px 22px rgba(0,0,0,.08);transform:translateY(-1px)}' +
      '.ecs-option.selected{border-color:var(--ecs-orange)}' +
      '.ecs-option .top{position:absolute;left:0;right:0;top:0;height:50%;background:#f3f4f6;display:flex;align-items:center;justify-content:center}' +
      '.ecs-icon{width:100px;height:100px;object-fit:contain;display:block}' +
      '.ecs-initial{width:60px;height:60px;border-radius:999px;background:#ffe8d8;color:#7c2d12;display:flex;align-items:center;justify-content:center;font-weight:900;font-size:22px}' +
      '.ecs-option .bottom{position:absolute;left:0;right:0;bottom:0;height:50%;display:flex;align-items:center;justify-content:center;text-align:center;padding:0 12px;font-weight:800;font-size:15px;line-height:1.2;background:#e6e6e6;color:#000}' +
      '.ecs-option.selected .bottom{background:var(--ecs-orange);color:#fff}' +
      '.ecs-selected-count{text-align:center;color:var(--ecs-muted);margin-top:12px;font-size:14px}' +
      '.ecs-other-field{max-width:38rem;margin:18px auto 0;padding:18px 20px;border:1px solid #e5e7eb;background:#f9fafb;border-radius:12px}' +
      '.ecs-other-label{display:block;font-size:15px;font-weight:800;color:#374151;margin-bottom:8px}' +
      '.ecs-other-input{width:100%;padding:13px 14px;border:1px solid #d1d5db;border-radius:10px;font-size:16px;font-family:inherit;background:#fff}' +
      '.ecs-other-help{font-size:13px;color:var(--ecs-muted);margin-top:8px;line-height:1.4}' +

      '.ecs-actions{margin-top:26px;display:grid;grid-template-columns:1fr auto 1fr;align-items:center;gap:14px}' +
      '@media(min-width:721px){.ecs-email-actions{display:flex!important;flex-direction:column!important;gap:12px!important;align-items:stretch!important}.ecs-email-actions .ecs-primary-wrap{order:1;width:100%}.ecs-email-actions .ecs-primary-wrap .ecs-btn{width:100%;padding:16px 32px}.ecs-email-actions .ecs-back{order:2;width:100%;padding:16px 32px;justify-self:auto}.ecs-email-actions>div:last-child{display:none}}' +
      '.ecs-btn{display:inline-flex;align-items:center;justify-content:center;border-radius:999px;padding:13px 24px;font-size:17px;font-weight:800;cursor:pointer;border:1px solid #d1d5db;background:#fff;color:#374151;transition:opacity .2s,box-shadow .2s;text-decoration:none}' +
      '.ecs-btn[disabled]{opacity:.4;cursor:not-allowed}' +
      '.ecs-btn-primary{background:var(--ecs-orange);color:#fff;border-color:transparent;padding:16px 32px}' +
      '.ecs-btn-primary:hover{opacity:.95}' +
      '.ecs-btn,.ecs-option,.ecs-option .bottom,.ecs-scale-btn,.ecs-choice-scale-btn,.ecs-input{font-family:inherit}' +
      '.ecs-back{justify-self:start}' +
      '.ecs-primary-wrap{justify-self:center}' +

      '.ecs-scale{max-width:44rem;margin:8px auto 0;padding:24px;border:1px solid #e5e7eb;border-radius:16px;background:#fff}' +
      '.ecs-scale-values{display:grid;grid-template-columns:repeat(5,1fr);gap:10px;margin-bottom:18px}' +
      '.ecs-scale-btn{height:58px;border-radius:14px;border:1px solid #d1d5db;background:#f3f4f6;font-weight:900;font-size:18px;cursor:pointer;color:#111}' +
      '.ecs-scale-btn.selected{background:var(--ecs-orange);border-color:var(--ecs-orange);color:#fff}' +
      '.ecs-scale-labels{display:flex;justify-content:space-between;gap:14px;color:#374151;font-size:17px;font-weight:800;margin-top:6px}' +

      '.ecs-choice-scale{max-width:44rem;margin:8px auto 0;padding:24px;border:1px solid #e5e7eb;border-radius:16px;background:#fff}' +
      '.ecs-choice-scale-values{display:grid;grid-template-columns:repeat(4,1fr);gap:12px}' +
      '.ecs-choice-scale-btn{height:64px;border-radius:14px;border:1px solid #d1d5db;background:#f3f4f6;font-weight:900;font-size:18px;cursor:pointer;color:#111}' +
      '.ecs-choice-scale-btn.selected{background:var(--ecs-orange);border-color:var(--ecs-orange);color:#fff}' +

      '.ecs-field-card{max-width:38rem;margin:12px auto 0;padding:24px;border:1px solid #e5e7eb;border-radius:16px;background:#fff}' +
      '.ecs-label{display:block;font-size:14px;margin-bottom:8px;color:#374151;font-weight:700}' +
      '.ecs-input{width:100%;padding:14px 16px;border:1px solid #d1d5db;border-radius:12px;font-size:16px}' +
      '.ecs-input[readonly]{background:#f3f4f6;color:#6b7280;cursor:not-allowed}' +
      '.ecs-help{color:var(--ecs-muted);font-size:14px;line-height:1.45;margin-top:10px}' +
      '.ecs-err{display:none;color:#b91c1c;font-size:14px;margin-top:8px}' +

      '.ecs-summary{max-width:48rem;margin:18px auto;padding:18px 20px;background:#f9fafb;border:1px solid #e5e7eb;border-radius:0}' +
      '.ecs-summary h3{font-size:18px;margin:0 0 10px;font-weight:800}' +
      '.ecs-summary ul{margin:0;padding-left:20px;color:#374151;line-height:1.55}' +
      '.ecs-summary li{margin:4px 0}' +

      '@media(max-width:720px){' +
        '.ecs-overlay{padding:0;align-items:stretch}' +
        '.ecs-modal{max-height:100vh;border-radius:0;width:100%;height:100vh}' +
        '.ecs-wrap{padding:58px 16px 32px}' +
        '.ecs-h2{font-size:24px}' +
        '.ecs-options{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px}' +
        '.ecs-option{width:100%;max-width:none;height:auto;aspect-ratio:1/1;border-radius:0}' +
        '.ecs-option .top{height:50%}' +
        '.ecs-option .bottom{height:50%;font-size:14px;padding:0 10px}' +
        '.ecs-actions{display:flex;flex-direction:column-reverse;align-items:stretch}' +
        '.ecs-btn{width:100%;padding:16px 22px}' +
        '.ecs-scale-values{gap:8px}' +
        '.ecs-scale-btn{height:52px}' +
        '.ecs-choice-scale{padding:18px}' +
        '.ecs-choice-scale-values{grid-template-columns:repeat(2,1fr);gap:10px}' +
        '.ecs-choice-scale-btn{height:58px;font-size:16px}' +
        '.ecs-close{right:10px;top:10px}' +
        '.ecs-split-card{grid-template-columns:1fr;max-width:100%;margin:0 auto 18px}' +
        '.ecs-split-media{min-height:auto;display:block}' +
        '.ecs-split-media img{width:100%;height:auto;aspect-ratio:1/1;object-fit:cover}' +
        '.ecs-split-content{padding:24px 18px}' +
        '.ecs-scale-labels{font-size:15px}' +
        '.ecs-other-field{padding:16px;margin-top:16px}' +
      '}' +

      '@media(max-width:420px){' +
        '.ecs-options{grid-template-columns:repeat(2,minmax(0,1fr));gap:16px}' +
        '.ecs-option{width:100%;height:auto;aspect-ratio:1/1;border-radius:0}' +
        '.ecs-option .top{height:50%}' +
        '.ecs-option .bottom{height:50%;font-size:13px;padding:0 8px}' +
        '.ecs-icon{width:82px;height:82px}' +
        '.ecs-initial{width:52px;height:52px;font-size:20px}' +
      '}';

    var style = document.createElement('style');
    style.id = 'archoil-existing-customer-survey-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function createModal() {
    if (document.getElementById('archoil-existing-customer-survey-overlay')) return;

    var overlay = el('div', {
      class: 'ecs-overlay',
      id: 'archoil-existing-customer-survey-overlay'
    }, []);

    var modal = el('div', {
      class: 'ecs-modal',
      role: 'dialog',
      'aria-modal': 'true',
      'aria-label': 'Archoil customer survey'
    }, []);

    var close = el('button', {
      class: 'ecs-close',
      type: 'button',
      'aria-label': 'Close survey',
      onclick: closeSurvey
    }, ['×']);

    var root = el('div', {
      class: 'ecs-root',
      id: 'archoil-existing-customer-survey-root'
    }, []);

    modal.appendChild(close);
    modal.appendChild(root);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    document.documentElement.classList.add('ecs-lock');

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closeSurvey();
    });

    document.addEventListener('keydown', handleEsc);
  }

  function handleEsc(event) {
    if (event.key === 'Escape') closeSurvey();
  }

  function closeSurvey() {
    var overlay = document.getElementById('archoil-existing-customer-survey-overlay');

    if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);

    document.documentElement.classList.remove('ecs-lock');
    document.removeEventListener('keydown', handleEsc);

    var email = knownEmail();

    if (email) {
      klaviyoTrack(EVENT_CLOSED, getAnswerProps(), email);
    }
  }

  function renderIcon(option) {
    var src = option.icon ? ICONS[option.icon] : '';

    if (src) return el('img', { class: 'ecs-icon', src: src, alt: '' }, []);

    var initial = String(option.label || '?').trim().charAt(0).toUpperCase();
    return el('div', { class: 'ecs-initial', 'aria-hidden': 'true' }, [initial]);
  }

  function selectOption(question, optionId) {
    var otherWasSelected = isOtherSelected(question);

    if (question.type === 'multi') {
      var current = Array.isArray(state.answers[question.id]) ? state.answers[question.id].slice() : [];
      var exists = current.indexOf(optionId) > -1;

      if (exists) {
        current = current.filter(function (id) {
          return id !== optionId;
        });
      } else {
        if (question.max_select && current.length >= question.max_select) return;
        current.push(optionId);
      }

      state.answers[question.id] = current;

      if (optionId === 'other' && current.indexOf('other') === -1 && state.otherText) {
        delete state.otherText[question.id];
      }
    } else {
      state.answers[question.id] = optionId;

      if (questionHasOther(question) && optionId !== 'other' && state.otherText) {
        delete state.otherText[question.id];
      }
    }

    var otherIsSelectedNow = isOtherSelected(question);
    if (!otherWasSelected && otherIsSelectedNow) {
      pendingOtherFocus = question.id;
    }

    persist();
    savePartialToKlaviyo(question);
    render();
    focusPendingOtherField();
  }

  function setScale(question, value) {
    state.answers[question.id] = String(value);
    persist();
    savePartialToKlaviyo(question);
    render();
  }

  function renderIntro(root) {
    var wrap = el('div', { class: 'ecs-wrap' }, []);
    var card = el('div', { class: 'ecs-split-card' }, []);

    var media = el('div', { class: 'ecs-split-media' }, []);
    if (CONFIG.intro.image) {
      media.appendChild(el('img', {
        src: CONFIG.intro.image,
        alt: 'Customer survey'
      }, []));
    }

    var content = el('div', { class: 'ecs-split-content' }, []);
    content.appendChild(el('div', { class: 'ecs-kicker' }, ['Customer Giveaway']));
    content.appendChild(el('h2', { class: 'ecs-h2' }, [CONFIG.intro.headline]));
    content.appendChild(el('p', { class: 'ecs-sub' }, [CONFIG.intro.subheading]));
    content.appendChild(el('button', {
      class: 'ecs-btn ecs-btn-primary',
      type: 'button',
      onclick: function () {
        state.started = true;
        state.index = 0;
        persist();

        var email = knownEmail();

        if (email) {
          klaviyoIdentify(email, getAnswerProps());
          klaviyoTrack(EVENT_STARTED, getAnswerProps(), email);
        }

        render();
        scrollSurveyToTop();
      }
    }, [CONFIG.intro.button]));

    card.appendChild(media);
    card.appendChild(content);
    wrap.appendChild(card);
    root.appendChild(wrap);
  }

  function renderProgress(wrap, idx, total) {
    var progress = Math.round((idx / Math.max(1, total)) * 100);

    wrap.appendChild(el('div', { class: 'ecs-meta' }, [
      el('div', {}, ['Question ', String(idx + 1), ' of ', String(total)]),
      el('div', {}, [String(progress), '%'])
    ]));

    wrap.appendChild(el('div', { class: 'ecs-progress' }, [
      el('div', { class: 'track' }, [
        el('div', { class: 'fill', style: 'width:' + progress + '%' }, [])
      ])
    ]));
  }

  function renderQuestion(root) {
    var questions = CONFIG.questions;
    var idx = Math.max(0, Math.min(state.index, questions.length - 1));
    state.index = idx;

    var question = questions[idx];
    var wrap = el('div', { class: 'ecs-wrap' }, []);

    renderProgress(wrap, idx, questions.length);

    var stage = el('div', { class: 'ecs-stage' }, []);
    stage.appendChild(el('h2', { class: 'ecs-h2' }, [question.title]));

    if (question.type === 'scale') {
      renderScaleQuestion(stage, question);
    } else if (question.display === 'button_scale') {
      renderButtonScaleQuestion(stage, question);
    } else {
      renderCardQuestion(stage, question);
    }

    renderQuestionActions(stage, question, idx, questions.length);

    wrap.appendChild(stage);
    root.appendChild(wrap);
  }

  function renderScaleQuestion(stage, question) {
    var scale = el('div', { class: 'ecs-scale' }, []);
    var values = el('div', { class: 'ecs-scale-values' }, []);

    for (var i = question.min; i <= question.max; i++) {
      (function (value) {
        var selected = String(state.answers[question.id] || '') === String(value);

        values.appendChild(el('button', {
          class: 'ecs-scale-btn' + (selected ? ' selected' : ''),
          type: 'button',
          onclick: function () {
            setScale(question, value);
          }
        }, [String(value)]));
      })(i);
    }

    scale.appendChild(values);
    scale.appendChild(el('div', { class: 'ecs-scale-labels' }, [
      el('span', {}, [question.min_label || 'Low']),
      el('span', {}, [question.max_label || 'High'])
    ]));

    stage.appendChild(scale);
  }

  function renderButtonScaleQuestion(stage, question) {
    var choiceScale = el('div', { class: 'ecs-choice-scale' }, []);
    var choiceValues = el('div', { class: 'ecs-choice-scale-values' }, []);

    (question.options || []).forEach(function (option) {
      var selected = state.answers[question.id] === option.id;

      choiceValues.appendChild(el('button', {
        class: 'ecs-choice-scale-btn' + (selected ? ' selected' : ''),
        type: 'button',
        onclick: function () {
          selectOption(question, option.id);
        }
      }, [option.label]));
    });

    choiceScale.appendChild(choiceValues);
    stage.appendChild(choiceScale);
  }

  function renderCardQuestion(stage, question) {
    var opts = el('div', { class: 'ecs-options' }, []);

    (question.options || []).forEach(function (option) {
      var selected = question.type === 'multi'
        ? (Array.isArray(state.answers[question.id]) && state.answers[question.id].indexOf(option.id) > -1)
        : state.answers[question.id] === option.id;

      opts.appendChild(el('button', {
        class: 'ecs-option' + (selected ? ' selected' : ''),
        type: 'button',
        onclick: function () {
          selectOption(question, option.id);
        }
      }, [
        el('div', { class: 'top' }, [renderIcon(option)]),
        el('div', { class: 'bottom' }, [option.label])
      ]));
    });

    stage.appendChild(opts);

    if (question.type === 'multi') {
      var count = Array.isArray(state.answers[question.id]) ? state.answers[question.id].length : 0;
      stage.appendChild(el('div', { class: 'ecs-selected-count' }, [
        'Selected ', String(count), question.max_select ? ' / ' + String(question.max_select) : ''
      ]));
    }

    if (isOtherSelected(question)) {
      stage.appendChild(renderOtherTextField(question));
    }
  }

  function renderOtherTextField(question) {
    var input = el('input', {
      class: 'ecs-other-input',
      type: 'text',
      maxlength: '250',
      placeholder: question.other_placeholder || 'Type your answer here',
      value: (state.otherText && state.otherText[question.id]) || '',
      'data-other-question': question.id,
      oninput: function () {
        setOtherText(question, input.value, false);
      },
      onchange: function () {
        setOtherText(question, input.value, true);
      },
      onblur: function () {
        setOtherText(question, input.value, true);
      }
    }, []);

    return el('div', { class: 'ecs-other-field' }, [
      el('label', { class: 'ecs-other-label' }, [question.other_prompt || 'Tell us more, if you’d like.']),
      input,
      el('div', { class: 'ecs-other-help' }, ['Optional'])
    ]);
  }

  function focusPendingOtherField() {
    if (!pendingOtherFocus) return;

    try {
      var selector = '.ecs-other-input[data-other-question="' + pendingOtherFocus + '"]';
      var input = document.querySelector(selector);
      if (!input) return;

      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () {
        try { input.focus(); } catch (_) {}
      }, 250);
    } catch (_) {}

    pendingOtherFocus = '';
  }

  function renderQuestionActions(stage, question, idx, total) {
    var actions = el('div', { class: 'ecs-actions' }, []);

    var back = el('button', {
      class: 'ecs-btn ecs-back',
      type: 'button',
      onclick: function () {
        state.index = Math.max(0, state.index - 1);
        persist();
        render();
        scrollSurveyToTop();
      }
    }, ['< Back']);

    if (idx === 0) back.setAttribute('disabled', 'disabled');

    var canProceed = !question.required || isAnswered(question);
    var nextText = idx === total - 1 ? 'Continue' : 'Next Question';

    var next = el('button', {
      class: 'ecs-btn ecs-btn-primary',
      type: 'button',
      onclick: function () {
        if (!canProceed) return;

        if (state.index < total - 1) {
          state.index++;
        } else {
          state.index = total;
        }

        persist();
        render();
        scrollSurveyToTop();
      }
    }, [nextText]);

    if (!canProceed) next.setAttribute('disabled', 'disabled');

    actions.appendChild(back);
    actions.appendChild(el('div', { class: 'ecs-primary-wrap' }, [next]));
    actions.appendChild(el('div', {}, []));

    stage.appendChild(actions);
  }

  function renderEmailStep(root) {
    var wrap = el('div', { class: 'ecs-wrap' }, []);

    wrap.appendChild(el('div', { class: 'ecs-meta' }, [
      el('div', {}, ['Final step']),
      el('div', {}, ['100%'])
    ]));

    wrap.appendChild(el('div', { class: 'ecs-progress' }, [
      el('div', { class: 'track' }, [
        el('div', { class: 'fill', style: 'width:100%' }, [])
      ])
    ]));

    var card = el('div', { class: 'ecs-split-card' }, []);

    var media = el('div', { class: 'ecs-split-media' }, []);
    if (CONFIG.emailStep.image) {
      media.appendChild(el('img', {
        src: CONFIG.emailStep.image,
        alt: 'Enter the giveaway'
      }, []));
    }

    var content = el('div', { class: 'ecs-split-content' }, []);
    content.appendChild(el('div', { class: 'ecs-kicker' }, ['Competition Entry']));
    content.appendChild(el('h2', { class: 'ecs-h2', style: 'margin-bottom:8px' }, [CONFIG.emailStep.headline]));
    content.appendChild(el('p', { class: 'ecs-sub' }, [CONFIG.emailStep.subheading]));

    var emailFromUrl = getEmailFromUrl();
var lockedEmail = !!emailFromUrl;

var emailInput = el('input', {
  class: 'ecs-input',
  type: 'email',
  autocomplete: 'email',
  placeholder: 'Email address',
  value: emailFromUrl || state.email || '',
  readonly: lockedEmail
}, []);

    var err = el('div', { class: 'ecs-err' }, ['Please enter a valid email address.']);

    content.appendChild(el('label', {
      class: 'ecs-label',
      style: 'text-align:left;max-width:34rem;margin:0 auto 8px;'
    }, ['Email address']));

    content.appendChild(el('div', {
      style: 'max-width:34rem;margin:0 auto;width:100%;'
    }, [emailInput]));

    content.appendChild(err);
    content.appendChild(el('div', { class: 'ecs-help' }, [CONFIG.emailStep.note]));

    var actions = el('div', {
      class: 'ecs-actions ecs-email-actions',
      style: 'max-width:34rem;margin:20px auto 0;width:100%;'
    }, []);

    var back = el('button', {
      class: 'ecs-btn ecs-back',
      type: 'button',
      onclick: function () {
        state.index = CONFIG.questions.length - 1;
        persist();
        render();
        scrollSurveyToTop();
      }
    }, ['< Back']);

    var submit = el('button', {
      class: 'ecs-btn ecs-btn-primary',
      type: 'button',
      onclick: function () {
        var email = emailFromUrl || String(emailInput.value || '').trim();

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          err.style.display = 'block';
          emailInput.focus();
          return;
        }

        err.style.display = 'none';
        state.email = email;
        state.completed = true;

        var props = getAllProps({
          customer_survey_entry_submitted: 'Yes'
        });

        klaviyoIdentify(email, props);
        klaviyoTrack(EVENT_SUBMITTED, props, email);
        klaviyoTrack(EVENT_ENTERED, props, email);

        persist();
        render();
        scrollSurveyToTop();
      }
    }, [CONFIG.emailStep.button]);

    actions.appendChild(back);
    actions.appendChild(el('div', { class: 'ecs-primary-wrap' }, [submit]));
    actions.appendChild(el('div', {}, []));

    content.appendChild(actions);

    card.appendChild(media);
    card.appendChild(content);
    wrap.appendChild(card);
    root.appendChild(wrap);
  }

  function renderCompletion(root) {
  var wrap = el('div', { class: 'ecs-wrap' }, []);

  var intro = el('div', { class: 'ecs-intro' }, []);
  intro.appendChild(el('div', { class: 'ecs-kicker' }, ['Survey Complete']));
  intro.appendChild(el('h2', { class: 'ecs-h2' }, [CONFIG.completion.headline]));
  intro.appendChild(el('p', { class: 'ecs-sub' }, [CONFIG.completion.subheading]));

  intro.appendChild(el('button', {
    class: 'ecs-btn ecs-btn-primary',
    type: 'button',
    onclick: closeSurvey
  }, [CONFIG.completion.button]));

  wrap.appendChild(intro);
  root.appendChild(wrap);
}

  function render() {
    var root = document.getElementById('archoil-existing-customer-survey-root');
    if (!root) return;

    clear(root);

    if (state.completed) return renderCompletion(root);
    if (!state.started) return renderIntro(root);
    if (state.index >= CONFIG.questions.length) return renderEmailStep(root);

    return renderQuestion(root);
  }

  function start() {
    if (!shouldOpenSurvey()) return;

    injectStyles();
    restore();

    state.email = getEmailFromUrl() || state.email;

    createModal();
    render();

    if (state.email) {
      klaviyoIdentify(state.email, getAnswerProps());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();